import { v4 } from 'uuid';

// src/helpers/tabletGeneratedIds.ts
var generateTabletGeneratedId = () => v4();
var generatePrintJobId = () => {
  const uuid = v4();
  const noDashUUID = uuid.replace(/-/g, "");
  return noDashUUID.slice(-20);
};

export { generatePrintJobId, generateTabletGeneratedId };
